import { render, staticRenderFns } from "./ScanForKNF.vue?vue&type=template&id=636959bf&scoped=true"
import script from "./ScanForKNF.vue?vue&type=script&lang=js"
export * from "./ScanForKNF.vue?vue&type=script&lang=js"
import style0 from "./ScanForKNF.vue?vue&type=style&index=0&id=636959bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636959bf",
  null
  
)

export default component.exports